import { NgModule } from '@angular/core';
import { WidgetDataService } from '../services';

@NgModule({
  providers: [WidgetDataService],
})
export class WidgetEntityStoreModule {}
